import { useEffect, useRef, useMemo } from 'react';
import { useFormikContext } from 'formik';
import { isEqual, debounce } from 'lodash-es';

export const ScorecardAutoSave = ({ onAutoSave, delay = 1000 }) => {
  const { values } = useFormikContext();
  const previousValuesRef = useRef(values);

  const debouncedAutoSave = useMemo(
    () =>
      debounce((v) => {
        const hasChanges = !isEqual(v, previousValuesRef.current);
        if (hasChanges) {
          onAutoSave(v);
          previousValuesRef.current = v;
        }
      }, delay),
    [onAutoSave, delay]
  );

  useEffect(() => {
    debouncedAutoSave(values);
  }, [values, debouncedAutoSave]);

  return null;
};
